module.exports = __webpack_public_path__ + "img/dialog-success.d5d67c9d.png";